import { RSFundPageModel } from '../../api.types';

/** Embedded time series still returned on some limit_status rows (legacy). */
export type ProspectusRestrictionsTimeSeries =
  | [
      ['Date', 'Value', 'Limit'],
      ...Array<[string, number | string, number | string]>,
    ]
  | [
      ['Date', 'Value', 'Limit'],
      ...Array<
        [
          string,
          { display: string; value: number | string },
          { limit: number | string; display: string },
        ]
      >,
    ];

/** One point from GET /prospectus_restrictions/timeseries/<fund_name>. */
export type ProspectusRestrictionsTimeSeriesPoint = {
  position_date: string;
  value: number;
  limit: number;
};

/** Response from GET /prospectus_restrictions/timeseries/<fund_name>. */
export type ProspectusRestrictionsTimeSeriesResponse = {
  rule_index: number;
  rule_name: string;
  time_series: ProspectusRestrictionsTimeSeriesPoint[];
};

export type FetchProspectusRestrictionsTimeSeriesParams = {
  fundName: string;
  ruleIndex: number;
  ruleName: string;
  startDate: string;
  endDate: string;
};

/** One row in `limit_status` (header row at index 0 is skipped in the UI). */
export type ProspectusRestrictionsLimitStatusRow = [
  name: string,
  status: string,
  limit: number | string,
  value: number | string,
  ...rest: unknown[],
];

export type ProspectusRestrictionsPosition = {
  gm_name: string;
  isin: string;
  gm_id: number;
  risk_factor: number;
  raw_position: number;
  market_price: number;
  risk_metric_value: number;
  exposure: number;
  country_code: string;
  base_currency: string;
  client_industry?: string;
  impacted_prospectus_rules: string[];
  [key: string]: unknown;
};

export type ProspectusRestrictionsPayload = {
  limit_status: ProspectusRestrictionsLimitStatusRow[];
  positions?: ProspectusRestrictionsPosition[];
  [key: string]: unknown;
};

export type ProspectusRestrictionsPageModel =
  RSFundPageModel<ProspectusRestrictionsPayload>;

export function isProspectusRestrictionsPayload(
  value: unknown,
): value is ProspectusRestrictionsPayload {
  return (
    !!value &&
    typeof value === 'object' &&
    Array.isArray((value as ProspectusRestrictionsPayload).limit_status)
  );
}

export function extractProspectusRestrictionsPayload(
  page: ProspectusRestrictionsPageModel | null | undefined,
): ProspectusRestrictionsPayload | null {
  const inner = page?.data;
  return isProspectusRestrictionsPayload(inner) ? inner : null;
}
